import { categoryItems,customerItem,eventItems,frontpage2SegmentItems,languageItems,shortURLItems,venueItems } from '@/data'; // Import local fallback data
import type { Category, Customer, EventItem, FrontpageSegment, Promoted, Venue } from '@/types';
import { mapDtosToCategories } from '@/utils/dtoTransformers/categoryDTO';
import { mapDtosToEventItems } from '@/utils/dtoTransformers/eventItemDTO';
import { mapDtosToPromoted } from '@/utils/dtoTransformers/promotedDTO';
import { mapDtosToVenues } from '@/utils/dtoTransformers/venueDTO';

export interface GeneralLists {
  events: EventItem[];
  moreEvents: EventItem[];
  venues: Venue[];
  categories: Category[];
  customer: Customer;
  promoted: Promoted[];
  frontpage2_segments: FrontpageSegment[];
  languages: string[];
  short_urls: Record<string, number>;
  rev: number | undefined;
  // Add more lists as needed
}

export async function fetchGeneralLists(): Promise<GeneralLists> {
  let events: EventItem[] = [];
  let moreEvents: EventItem[] = [];
  let venues: Venue[] = [];
  let categories: Category[] = [];
  let customer: Customer;
  let promoted: Promoted[] = [];
  let frontpage2_segments: FrontpageSegment[] = [];
  let languages: string[] = [];
  let short_urls: Record<string, number> = {};
  let rev: number | undefined = undefined;

  try {
    const response = await fetch('/of2/json/general', {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const data = await response.json();
    // console.log("Fetched general lists data:", data);

    events = Array.isArray(data.events) ? mapDtosToEventItems(data.events) : [];
    moreEvents = [];
    const rawVenues = Array.isArray(data.venues) ? data.venues : Object.values(data.venues ?? {});
    venues = mapDtosToVenues(rawVenues);
    categories = Array.isArray(data.categories) ? mapDtosToCategories(data.categories) : [];
    customer = data.customer as Customer;
    promoted = Array.isArray(data.promoted) ? mapDtosToPromoted(data.promoted) : [];
    frontpage2_segments = Array.isArray(data.frontpage2_segments) ? data.frontpage2_segments : [];
    languages = Array.isArray(data.languages) ? data.languages : [];
    short_urls = data.short_urls !== null ? data.short_urls : {};
    rev = typeof data.rev === 'number' ? data.rev : undefined;
  } catch (e) {
    console.error("Failed to fetch general lists:", e);
    // Temporary fallback for frontend testing if backend is broken
    // TODO replace fallback data with empty lists [] {}
    events = eventItems;
    moreEvents = [];
    venues = venueItems;
    categories = categoryItems;
    customer = customerItem;
    promoted = [];
    frontpage2_segments = frontpage2SegmentItems;
    languages = languageItems;
    short_urls = shortURLItems;
    rev = undefined;
    // Remove this fallback when backend is stable
  }

  return {
    events,
    moreEvents,
    venues,
    categories,
    customer,
    promoted: promoted || [],
    frontpage2_segments,
    languages,
    short_urls,
    rev,
    // Add more lists here
  };
}